<template>
  <div>
    <KvTable :items="items" class="search_box" @click="$modal.hide('notification-modal')"></KvTable>
    <img
        src="/images/ic/comm/ic-search.svg"
        alt=""
    >
  </div>
</template>
<script>
import KvTable from '../../../../src/components/Table/kvTable/index'
import {mapActions} from 'vuex'

export default {
  name: 'SearchMenu',
  props: ['refinedPatientListProps'],
  components: {
    KvTable
  },
  data() {
    const item = [
      {
        index: 0,
        keyTitle: '',
        keyType: 'SearchSelectBox',
        class: '',
        keyRange: this.refinedPatientListProps,
        values: ''
      }
    ];
    return {
      items: item
    };
  },
  methods: {
    ...mapActions([
      'inspectSelectPatient',
      'resetReport'
    ]),
    selectPatient(seqPatient) {
      this.inspectSelectPatient(seqPatient);
      this.$router.push(`/patientList/details/home?id=${seqPatient}`);
      this.items[0].values = '';
      this.resetReport();
    }
  },
  watch: {
    items: {
      deep: true,
      handler(newVal) {
        if (newVal[0].values?.seqPatient) {
          this.selectPatient(newVal[0].values.seqPatient);
        }
      }
    },
    refinedPatientListProps: {
      deep: true,
      handler(newVal) {
        const item = [
          {
            index: 0,
            keyTitle: '',
            keyType: 'SearchSelectBox',
            class: '',
            keyRange: newVal,
            values: ''
          }
        ];
        this.items = item;
      }
    }

  },
}
</script>